import { type } from 'jquery';
import * as IncomeStatementService from '../services/IncomeStatementService';

export const GET_INCOME_STATEMENT_DETAILS = 'GET_INCOME_STATEMENT_DETAILS';
export const GET_MARK_AS_Reviewed_DETAILS = "GET_MARK_AS_Reviewed_DETAILS";
export const GET_MARK_AS_Reviewed_DETAILS_BY_ID = "GET_MARK_AS_Reviewed_DETAILS_BY_ID";
export const UPDATE_CUSTOM_FILEDS = "UPDATE_CUSTOM_FILEDS";
export const GET_EDIT_ARCHIED_DATA = "GET_EDIT_ARCHIED_DATA";

export const GetIncomeStatementData = (param) => {
  return (dispatch) => {
    IncomeStatementService.GetIncomeStatementAccountsData(param)
      .then((response) => {
        dispatch({ type: GET_INCOME_STATEMENT_DETAILS, payload: response });
      });
  }
}

export const UpdateAccountsCommentNotes = (body) => {
  return (dispatch) => {
    return IncomeStatementService.UpdateAccountsCommentNotes(body)
      .then((response) => {
        dispatch({ type: 'UPDATE_COMMENT_NOTES', payload: response });
        return response;
      });
  };
};

export const UpdateAccountsQuestion = (body) => {
  return (dispatch) => {
    return IncomeStatementService.UpdateAccountsQuestion(body)
      .then((response) => {
        dispatch({ type: 'UPDATE_QUESTION', payload: response });
        return response;
      });
  };
};

// actions/incomeStatementActions.js
export const MarkAsReviewed = (body) => {
  return async (dispatch) => {
    try {
      const response = await IncomeStatementService.MarkAsReviewed(body);
      dispatch({
        type: 'MARK_AS_REVIEWED',
        payload: response
      });
      return response;
    } catch (error) {
      console.error('Error in markAsReviewed:', error);
      throw error;
    }
  };
};

export const GetMarkAsReviewedHistoryList = (param) => {
  return (dispatch) => {
    return IncomeStatementService.GetMarkAsReviewedHistoryList(param)
      .then((response) => {
        dispatch({
          type: GET_MARK_AS_Reviewed_DETAILS,
          payload: response
        });
      });
  };
};

export const GetMarkAsReviewedHistoryById = (param) => {
  return (dispatch) => {
    return IncomeStatementService.GetMarkAsReviewedHistoryById(param)
      .then((response) => {
        dispatch({
          type: GET_MARK_AS_Reviewed_DETAILS_BY_ID,
          payload: response
        })
      });
  };
};

export const EditReviewedAccountCustomField = (body) => {
  return (dispatch) => {
    return IncomeStatementService.EditReviewedAccountCustomField(body)
      .then((response) => {
        dispatch({
          type: UPDATE_CUSTOM_FILEDS,
          payload: response
        })
        return response
      });
  };
};


